export const NAV_ITEMS = [
  { id: 'castings',  label: '공고 찾기', path: '/castings' },
  { id: 'talents',   label: '배우 찾기', path: '/talents' },
  { id: 'partners',  label: '파트너스', path: '/partners' },
  { id: 'community', label: '커뮤니티',  path: '/community' },
  { id: 'mypage',    label: '마이페이지', path: null }, // 로그인 상태에 따라 동적 처리
];
